import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MaintenanceService } from 'src/app/api/services';
import { checkInsurerMaintenance, checkInsurerMaintenanceFailure, checkInsurerMaintenanceSuccess, checkKioskMaintenance, checkKioskMaintenanceFailure, checkKioskMaintenanceSuccess } from './maintenance.actions';



@Injectable()
export class MaintenanceEffects {
  constructor(private actions$: Actions, private maintenanceService: MaintenanceService) { }

  public checkKioskMaintenance$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(checkKioskMaintenance),
      switchMap(({ kioskId }) =>
        this.maintenanceService.maintenanceCheckKioskMaintenance({ kioskId: kioskId.toString() }).pipe(
          map((maintenance) => checkKioskMaintenanceSuccess({ data: maintenance })),
          catchError((err) => of(checkKioskMaintenanceFailure({ error: err })))
        )
      )
    );
  });

  public checkInsurerMaintenance$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(checkInsurerMaintenance),
      switchMap(({ insurerId }) =>
        this.maintenanceService.maintenanceCheckInsurerMaintenance({insurerId:insurerId}).pipe(
          map((maintenance) => checkInsurerMaintenanceSuccess({ data: maintenance })),
          catchError((err) => of(checkInsurerMaintenanceFailure({ error: err })))
        )
      )
    );
  });
}
